import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, tap } from 'rxjs';

import { CustomBankService } from 'src/app/shared/services/custom-bank.service';
import {
  deleteCustomBank,
  editCustomBank,
  loadCustomBank,
  loadCustomBankSuccess,
  saveCustomBank,
} from './custom-bank.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class CustomBankEffects {
  constructor(private service: CustomBankService, private action$: Actions, private notify: NotifyService) {}

  loadCustomBank$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadCustomBank),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadCustomBankSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveCustomBank$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveCustomBank),
      concatMap(({ customBank }) =>
        this.service.save(customBank).pipe(
          tap(() => this.notify.saveSuccess()),
          map((res) => loadCustomBank()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  editCustomBank$ = createEffect(() =>
    this.action$.pipe(
      ofType(editCustomBank),
      concatMap(({ customBank, id }) =>
        this.service.edit(customBank, id).pipe(
          tap(() => this.notify.editSuccess()),
          map((res) => loadCustomBank()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  deleteCustomBank$ = createEffect(() =>
    this.action$.pipe(
      ofType(deleteCustomBank),
      concatMap(({ id }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => loadCustomBank()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
